import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { selectLocale } from '../reducers/locales';
import ReactModal from 'react-modal';
import VM from 'scratch-vm';
import ScratchBlocks from 'scratch-blocks';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import {
    btnHideTrue,
    btnHideFalse,
    openShowTitle,
    closeShowTitle
} from '../reducers/menus.js'
import {
    setActiveId
} from '../reducers/targets';

import ErrorBoundaryHOC from '../lib/error-boundary-hoc.jsx';
import {
    getIsError,
    getIsShowingProject
} from '../reducers/project-state';
import { setProjectTitle } from '../reducers/project-title';
import {
    activateTab,
    activeItem,
    BLOCKS_TAB_INDEX,
    COSTUMES_TAB_INDEX,
    SOUNDS_TAB_INDEX,
    editorTabInitialState,
    tabsActive,
    setShowMenuStage
} from '../reducers/editor-tab';

import {
    closeCostumeLibrary,
    closeBackdropLibrary,
    closeTelemetryModal,
    openExtensionLibrary
} from '../reducers/modals';

import {
    setConfig
} from '../reducers/downloadAlert.js';

import {
    runPythonFalse,
    runPythonTrue,
    runCTrue,
    runCFalse
} from '../reducers/btn-list.js';

import {
    setCodeValue
} from '../reducers/monacode.js';

import {
    handleDisconnect,
    disconnectE7,
    connectE7Robot
} from '../lib/get-Link-fn.js';

import FontLoaderHOC from '../lib/font-loader-hoc.jsx';
import LocalizationHOC from '../lib/localization-hoc.jsx';
import ProjectFetcherHOC from '../lib/project-fetcher-hoc.jsx';
import ProjectSaverHOC from '../lib/project-saver-hoc.jsx';
import QueryParserHOC from '../lib/query-parser-hoc.jsx';
import storage from '../lib/storage';
import vmListenerHOC from '../lib/vm-listener-hoc.jsx';
import vmManagerHOC from '../lib/vm-manager-hoc.jsx';
import cloudManagerHOC from '../lib/cloud-manager-hoc.jsx';

import GUIComponent from '../components/gui/gui.jsx';
import { setIsScratchDesktop } from '../lib/isScratchDesktop.js';
import robotSuit from '../lib/libraries/robots.js';

import { STAGE_SIZE_MODES } from '../lib/layout-constants';
import { setStageSize } from '../reducers/stage-size';

const messages = defineMessages({
    defaultProjectTitle: {
        id: 'gui.gui.defaultProjectTitle',
        description: 'Default title for project',
        defaultMessage: 'Scratch Project'
    }
});
let timeout;
class GUI extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            blockbtn: 0,
            downloadBtnBoxClose: 0,
            logoutbtn: 0,
            closeRobotLibrary: true,
            robotActive: null,
            link: false,
            bubble: false,
            hasUpdate: false,
            updateProgress: 0,
            isUpdateBox: false,
            version: {
                name: 'E6',
                current: '1',
                lastest: '1'
            },
            softwareVersion: {
                current: '1',
                lastest: '1'
            },
            showStage: false,
        };
        this.blocksData = ScratchBlocks
        bindAll(this, [
            'handleBlockClose',
            'handleDownloadBtnBoxClick',
            'domslist',
            'handleToBlockpanel',
            'handleToEditpanel',
            'handlesignOut',
            'handleNewRobotClick',
            'handleCloseLibrary',
            'handleOpenLibrary',
            'handleRobotActive',
            'handleSetTrue',
            'handleSetFalse',
            'handleSetupdateProgress',
            'handleSetVersion',
            'handleChangeWidth',
            'changeLang'
        ])
    }
    componentDidMount() {
        setIsScratchDesktop(this.props.isScratchDesktop);
        this.setReduxTitle(this.props.projectTitle);
        this.props.onStorageInit(storage);
        window.__yourReactComp__ = this;
        window.downloadAlert = this.props.downloadset
        //window.onbeforeunload = function(){
        //    return null
        //}
    }

    componentDidUpdate(prevProps) {
        if (this.props.projectId !== prevProps.projectId && this.props.projectId !== null) {
            this.props.onUpdateProjectId(this.props.projectId, this.props.vm);
        }
        if (this.props.projectTitle !== prevProps.projectTitle) {
            this.setReduxTitle(this.props.projectTitle);
        }


    }
    // 供mobile端外壳调用，更改语言
    changeLang(lang) {
        var p = new Promise((resolve, reject) => {
            const newLocale = lang;
            if (this.props.messagesByLocale[newLocale]) {
                this.props.onChangeLanguage(newLocale);
                document.documentElement.lang = newLocale;
            }
            resolve()
        })
        p.then(() => {
            window.downloadAlert({
                show: true,
                type: 'Info',
                content: '更改语言成功',
                animation: true,
                duration: 2500
            })
        })
    }
    setReduxTitle(newTitle) {
        if (newTitle === null || typeof newTitle === 'undefined') {
            this.props.onUpdateReduxProjectTitle(
                this.props.intl.formatMessage(messages.defaultProjectTitle)
            );
        } else {
            this.props.onUpdateReduxProjectTitle(newTitle);
        }
    }
    setshowHideStage() {
        if (this.props.stageSizeMode != 'closeStatus') {
            this.props.onSetCloseStatus()
        } else {
            this.props.onSetShowStatus()
        }
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 0);
        this.props.vm.closePanel();
        // if(document.getElementsByClassName('CodeMirror')[0] != undefined){
        //     document.getElementsByClassName('CodeMirror')[0].style.width = '100%';
        // }
    }
    handleclosePanel() {
        this.props.vm.closePanel();
    }
    handleChangeWidth(e) {
        e.preventDefault()
        if (document.getElementsByClassName('stop-all_draggabe-line-right_2douS')[0]) {
            var code = document.getElementsByClassName('stop-all_draggabe-line-right_2douS')[0].parentNode;
        } else {
            var code = document.getElementsByClassName('stop-all_draggabe-line_2YKF2')[0].parentNode;
        }
        var Rtl = this.props.isRtl
        var width = code.clientWidth;
        var titledocuemnt = code.childNodes[0].children[0];
        var contentdocument = code.childNodes[2];
        if (ScratchBlocks.getalls().is_mobi) {
            var touchcurrent = e.touches[0].clientX
            document.ontouchmove = function (e) {
                var num = touchcurrent - e.touches[0].clientX
                var changewidth = width + num
                code.style.width = changewidth + 'px';
                titledocuemnt.style.width = changewidth + 'px';
                contentdocument.style.width = changewidth + 'px';
            };
            document.ontouchend = function (e) {
                document.ontouchmove = null;
                document.ontouchend = null;
            };
        } else {
            var current = e.clientX;
            document.onmousemove = function (e) {
                var num = current - e.clientX
                var changewidth = Rtl ? e.clientX : (width + num)
                code.style.width = changewidth + 'px';
                titledocuemnt.style.width = changewidth + 'px';
                contentdocument.style.width = changewidth + 'px';
            };

            document.onmouseup = function () {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }



    }
    handleBlockClose() {
        if (this.state.blockbtn) {
            this.setState({
                blockbtn: 0
            });
        } else {
            this.setState({
                blockbtn: 1
            });
        }
        // 通过添加全局监听事件来实现点击任意区域缩起已展开的列表
        document.addEventListener('click', this.domslist, false)
    }
    handleDownloadBtnBoxClick() {
        if (this.state.downloadBtnBoxClose) {
            this.setState({
                downloadBtnBoxClose: 0
            })
        } else {
            this.setState({
                downloadBtnBoxClose: 1
            })
        }
        document.addEventListener('click', this.domslist, false)
    }
    handleToBlockpanel() {
        this.props.openShowTitle()
    }

    handleToEditpanel() {
        // 关闭积木输入框选中状态
        if (document.getElementsByClassName('fieldTextInput')[0] != undefined) {
            document.getElementsByClassName('fieldTextInput')[0].style.display = 'none';
        }
        if (document.getElementsByClassName('blocklyDropDownDiv')[0] != undefined) {
            document.getElementsByClassName('blocklyDropDownDiv')[0].style.display = 'none';
        }
        this.props.closeShowTitle()
    }

    // 当有列表展开时，监听全局点击后触发。
    domslist() {
        this.setState({
            blockbtn: 0,
            logoutbtn: 0,
            downloadBtnBoxClose: 0
        });
        document.removeEventListener('click', this.domslist, false)
    }

    handlesignOut() {
        if (this.state.logoutbtn == 1) {
            this.setState({
                logoutbtn: 0
            });
        } else if (this.state.logoutbtn == 0) {
            this.setState({
                logoutbtn: 1
            });
        }
        document.addEventListener('click', this.domslist, false)
    }

    handleChangeCode() {
        this.props.vm.toCode();
    }

    handleCloseLibrary(e) {
        let closeId = e.target.parentNode.id
        let id = e.target.id
        if (id == 'robotBg' || id == 'closeRobot' || closeId == 'closeRobot') {
            this.setState({
                closeRobotLibrary: true,
                robotActive: null
            })
        }

    }
    handleNewRobotClick() {
        this.setState({
            closeRobotLibrary: false
        })
    }
    handleOpenLibrary() {
        this.setState({
            closeRobotLibrary: true,
            robotActive: null
        });
        // 打开新的控制器要断掉之前连接的控制器
        if (this.state.link) {
            handleDisconnect(this.props.vm.robotType);
        }
        const preType = this.props.vm.robotType
        const robots = robotSuit(this.props.intl.formatMessage)
        const index = this.state.robotActive
        if (index !== null) {
            this.props.vm.addSprite(JSON.stringify(robots[this.state.robotActive])).then(() => {
                const robot = this.props.vm.runtime.targets.filter(target => target.isRobot);
                const num = robot.length - 1;
                this.props.vm.setEditingTarget(robot[num].id);
                this.props.vm.setDefaultOptions(robot[num]);
                this.props.onSetActiveId(this.props.vm.editingTarget.id);
                this.handleToBlockpanel()
                if (this.props.vm.robotType == "E7") {
                    connectE7Robot()
                } else {
                    disconnectE7(true)
                }
            })


        }

    }
    handleRobotActive(index) {
        this.setState({
            robotActive: index
        });
    }

    handleSetTrue(datas) {
        setTimeout(() => {
            this.setState({
                [datas]: true
            })
        }, 0)
    }
    handleSetFalse(datas) {
        setTimeout(() => {
            this.setState({
                [datas]: false
            })
        }, 0)

    }

    handleSetupdateProgress(num) {
        this.setState({
            updateProgress: num
        })
    }

    handleSetVersion(data) {
        this.setState({
            version: {
                name: data.name,
                current: data.current,
                lastest: data.lastest
            }
        })
    }


    render() {
        if (this.props.isError) {
            throw new Error(
                `Error in Scratch GUI [location=${window.location}]: ${this.props.error}`);
        }
        const {
            /* eslint-disable no-unused-vars */
            assetHost,
            cloudHost,
            error,
            isError,
            isScratchDesktop,
            isShowingProject,
            onStorageInit,
            onUpdateProjectId,
            onUpdateReduxProjectTitle,
            projectHost,
            projectId,
            projectTitle,
            /* eslint-enable no-unused-vars */
            children,
            fetchingProject,
            isLoading,
            loadingStateVisible,
            messagesByLocale,
            onChangeLanguage,
            ...componentProps
        } = this.props;
        return (
            <GUIComponent
                loading={fetchingProject || isLoading || loadingStateVisible}
                showHideStage={() => { this.setshowHideStage() }}
                closePanel={() => { this.handleclosePanel() }}
                onChangeWidth={this.handleChangeWidth}
                onChangeCode={() => { this.handleChangeCode() }}
                blockClose={this.handleBlockClose}
                isClose={this.state.blockbtn}
                downloadBtnBoxClose={this.state.downloadBtnBoxClose}
                downloadBtnBoxClick={this.handleDownloadBtnBoxClick}
                roledate={this.state.pressDownRole}
                clickToBlockpanel={this.handleToBlockpanel}
                clickToEditpanel={this.handleToEditpanel}
                signOut={this.handlesignOut}
                isLogout={this.state.logoutbtn}
                onNewRobotClick={this.handleNewRobotClick}
                CloseLibrary={this.handleCloseLibrary}
                closeRobotLibrary={this.state.closeRobotLibrary}
                openLibrary={this.handleOpenLibrary}
                robotItemActive={this.handleRobotActive}
                robotActive={this.state.robotActive}
                link={this.state.link}
                bubble={this.state.bubble}
                hasUpdate={this.state.hasUpdate}
                setStateTrue={this.handleSetTrue}
                setStateFalse={this.handleSetFalse}
                updateProgress={this.state.updateProgress}
                setupdateProgress={this.handleSetupdateProgress}
                version={this.state.version}
                handleSetVersion={this.handleSetVersion}
                softwareVersion={this.state.softwareVersion}
                isUpdateBox={this.state.isUpdateBox}
                showStage={this.state.showStage}
                onUpdateProjectTitle={onUpdateReduxProjectTitle}
                {...componentProps}
            >
                {children}
            </GUIComponent>
        );
    }
}

GUI.propTypes = {
    assetHost: PropTypes.string,
    children: PropTypes.node,
    cloudHost: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    fetchingProject: PropTypes.bool,
    importInfoVisible: PropTypes.bool,
    intl: intlShape,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    isScratchDesktop: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    loadingStateVisible: PropTypes.bool,
    onSeeCommunity: PropTypes.func,
    onStorageInit: PropTypes.func,
    onUpdateProjectId: PropTypes.func,
    onUpdateProjectTitle: PropTypes.func,
    onUpdateReduxProjectTitle: PropTypes.func,
    previewInfoVisible: PropTypes.bool,
    projectHost: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    projectTitle: PropTypes.string,
    telemetryModalVisible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired,
    downloadConfig: PropTypes.object,
    monacodeValue: PropTypes.string
};

GUI.defaultProps = {
    isScratchDesktop: false,
    onStorageInit: storageInstance => storageInstance.addOfficialScratchWebStores(),
    onUpdateProjectId: () => { }
};

const mapStateToProps = state => {
    const loadingState = state.scratchGui.projectState.loadingState;

    return {
        messagesByLocale: state.locales.messagesByLocale,
        activeTabIndex: state.scratchGui.editorTab.activeTabIndex,
        alertsVisible: state.scratchGui.alerts.visible,
        backdropLibraryVisible: state.scratchGui.modals.backdropLibrary,
        blocksTabVisible: state.scratchGui.editorTab.activeTabIndex === BLOCKS_TAB_INDEX,
        cardsVisible: state.scratchGui.cards.visible,
        connectionModalVisible: state.scratchGui.modals.connectionModal,
        costumeLibraryVisible: state.scratchGui.modals.costumeLibrary,
        costumesTabVisible: state.scratchGui.editorTab.activeTabIndex === COSTUMES_TAB_INDEX,
        error: state.scratchGui.projectState.error,
        importInfoVisible: state.scratchGui.modals.importInfo,
        isError: getIsError(loadingState),
        isPlayerOnly: state.scratchGui.mode.isPlayerOnly,
        isRtl: state.locales.isRtl,
        isShowingProject: getIsShowingProject(loadingState),
        loadingStateVisible: state.scratchGui.modals.loadingProject,
        previewInfoVisible: state.scratchGui.modals.previewInfo,
        projectId: state.scratchGui.projectState.projectId,
        downloadC: state.scratchGui.vm.downloadC.bind(state.scratchGui.vm),
        soundsTabVisible: state.scratchGui.editorTab.activeTabIndex === SOUNDS_TAB_INDEX,
        targetIsStage: (
            state.scratchGui.targets.stage &&
            state.scratchGui.targets.stage.id === state.scratchGui.targets.editingTarget
        ),
        telemetryModalVisible: state.scratchGui.modals.telemetryModal,
        tipsLibraryVisible: state.scratchGui.modals.tipsLibrary,
        tabsActiveIndex: state.scratchGui.editorTab.tabsActiveIndex,
        vm: state.scratchGui.vm,
        turbo: state.scratchGui.vmStatus.turbo,
        isfeedback: state.scratchGui.modals.isfeedback,
        btnhide: state.scratchGui.menus.isbtnhide,
        showtitle: state.scratchGui.menus.showtitle,
        islogin: state.scratchGui.modals.islogin,
        stageSizeMode: state.scratchGui.stageSize.stageSize,
        showMenuStage: state.scratchGui.editorTab.showMenuStage,
        downloadConfig: state.scratchGui.downloadAlert.donwloadConfig,
        history: state.scratchGui.targets.questionHistory,
        questions: state.scratchGui.targets.questions,
        showStormOslink: state.scratchGui.menus.showlink,
        linkTab: state.scratchGui.menus.link_tab,
        monacodeValue: state.scratchGui.monacodes.value,
        isUploadE7: state.scratchGui.modals.uploadE7
    };
};

const mapDispatchToProps = (dispatch, props) => ({
    onChangeLanguage: locale => {
        dispatch(selectLocale(locale));
    },
    onExtensionButtonClick: () => dispatch(openExtensionLibrary()),
    onActivateTab: tab => dispatch(activateTab(tab)),
    onActivateCostumesTab: () => {
        if (window.__yourReactComp__.props.showMenuStage == 'block' ||
            window.__yourReactComp__.props.showMenuStage == 'sounds') {
            dispatch(setShowMenuStage('costumes'))
            dispatch(activateTab(COSTUMES_TAB_INDEX));
        } else {
            dispatch(setShowMenuStage('block'))
            dispatch(activateTab(0));
        }

    },
    onActivateSoundsTab: () => {
        if (window.__yourReactComp__.props.showMenuStage == 'costumes' ||
            window.__yourReactComp__.props.showMenuStage == 'block') {
            dispatch(setShowMenuStage('sounds'))
            dispatch(activateTab(SOUNDS_TAB_INDEX));
        } else {
            dispatch(setShowMenuStage('block'))
            dispatch(activateTab(0));
        }
    },
    onRequestCloseBackdropLibrary: () => dispatch(closeBackdropLibrary()),
    onRequestCloseCostumeLibrary: () => dispatch(closeCostumeLibrary()),
    onRequestCloseTelemetryModal: () => dispatch(closeTelemetryModal()),
    onUpdateReduxProjectTitle: title => dispatch(setProjectTitle(title)),
    onActiveItemOne: () => {

        dispatch(tabsActive(0))

        var code = document.getElementById('codeSmallBtn')
        code.style.display = 'block';

        dispatch(setShowMenuStage('block'))
        dispatch(activateTab(0));
    },
    onActiveItemTwo: (a) => {

        dispatch(tabsActive(1))
        var code = document.getElementById('codeSmallBtn')
        var codebox = document.getElementsByClassName('stop-all_codeBox_-7lLW')[0] || document.getElementsByClassName('stop-all_codeBox-right_2Dzqh')[0]
        code.style.display = 'none';
        codebox.style.display = 'none';

        dispatch(setShowMenuStage('block'))
        dispatch(activateTab(0));
    },
    onActiveItemThree: () => {

        dispatch(tabsActive(2))
        var code = document.getElementById('codeSmallBtn')
        var codebox = document.getElementsByClassName('stop-all_codeBox_-7lLW')[0] || document.getElementsByClassName('stop-all_codeBox-right_2Dzqh')[0]
        code.style.display = 'none';
        codebox.style.display = 'none';

        dispatch(setShowMenuStage('block'))
        dispatch(activateTab(0));
    },
    openShowTitle: () => {
        dispatch(openShowTitle())
    },
    closeShowTitle: () => {
        dispatch(closeShowTitle())
    },
    onSetCloseStatus: () => {
        dispatch(setStageSize(STAGE_SIZE_MODES.closeStatus));
    },
    onSetShowStatus: () => {
        dispatch(setStageSize(STAGE_SIZE_MODES.small));
    },
    btnTrue: () => {
        dispatch(btnHideTrue())
    },
    btnFalse: () => {
        dispatch(btnHideFalse())
    },
    onSetActiveId: (id) => {
        dispatch(setActiveId(id))
    },
    downloadset: (config) => {
        dispatch(setConfig(config));
    },
    setRunningStatus: (type, status) => {
        // 首先判断是以python调试还是以c调试（即判断是E6M6需要改变图标还是C1)
        // 其次需要传入true或false给全局state中isRunC或isRunPython
        // 从而控制调试图标的变化
        if (type === 'python') {
            if (status) {
                dispatch(runPythonTrue());
            } else {
                dispatch(runPythonFalse());
            }
        } else if (type === 'c') {
            if (status) {
                dispatch(runCTrue());
            } else {
                dispatch(runCFalse());
            }
        } else if (type === 'all') {
            if (status) {
                dispatch(runPythonTrue());
                dispatch(runCTrue());
            } else {
                dispatch(runPythonFalse());
                dispatch(runCFalse());
            }
        }
    },
    setMonaCodeValue: (code) => {
        dispatch(setCodeValue(code))
    }
});

const ConnectedGUI = injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps,
)(GUI));

// note that redux's 'compose' function is just being used as a general utility to make
// the hierarchy of HOC constructor calls clearer here; it has nothing to do with redux's
// ability to compose reducers.
const WrappedGui = compose(
    LocalizationHOC,
    ErrorBoundaryHOC('Top Level App'),
    FontLoaderHOC,
    QueryParserHOC,
    ProjectFetcherHOC,
    ProjectSaverHOC,
    vmListenerHOC,
    vmManagerHOC,
    cloudManagerHOC
)(ConnectedGUI);

WrappedGui.setAppElement = ReactModal.setAppElement;
export default WrappedGui;
